import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
} from '@chakra-ui/react';

function Dashboard() {
  const products= [];
  const orders = [];

  return (
    <Box>
      <SimpleGrid columns={3} spacing={6}>
        <Stat
          p={6}
          shadow="base"
          rounded="lg"
          borderWidth="1px"
        >
          <StatLabel>Total Products</StatLabel>
          <StatNumber>{products?.length || 0}</StatNumber>
          <StatHelpText>Active products in store</StatHelpText>
        </Stat>
        <Stat
          p={6}
          shadow="base"
          rounded="lg"
          borderWidth="1px"
        >
          <StatLabel>Total Orders</StatLabel>
          <StatNumber>{orders?.length || 0}</StatNumber>
          <StatHelpText>All time orders</StatHelpText>
        </Stat>
        <Stat
          p={6}
          shadow="base"
          rounded="lg"
          borderWidth="1px"
        >
          <StatLabel>Revenue</StatLabel>
          <StatNumber>
            $0
          </StatNumber>
          <StatHelpText>Total revenue</StatHelpText>
        </Stat>
      </SimpleGrid>
    </Box>
  );
}

export default Dashboard;